import { render, staticRenderFns } from "./SafetyHero.vue?vue&type=template&id=5a79c463&scoped=true&"
import script from "./SafetyHero.vue?vue&type=script&lang=js&"
export * from "./SafetyHero.vue?vue&type=script&lang=js&"
import style0 from "./SafetyHero.vue?vue&type=style&index=0&id=5a79c463&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a79c463",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VParallax } from 'vuetify/lib/components/VParallax';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VImg,VParallax,VRow})
